import styled from 'styled-components'

export const StyledEconomicWrapper = styled.div`
  width: 100%;
  padding-top: 79px;
  background: #f6f8fb;
  padding-bottom: 30px;

  .economic-mechanism-title {
    font-style: normal;
    font-weight: normal;
    font-size: 28px;
    line-height: 42px;
    color: #21213e;
    text-align: center;
    margin-bottom: 11px;
  }

  .economic-mechanism-detail-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 1219px;
    margin: auto;
  }
  @media screen and (max-width: 640px) {
    padding: 79px 34px 30px 34px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .economic-detail-img {
      width: 45px;
      height: 45px;
    }

    .economic-detail-info-description {
      font-size: 17px !important;
    }

    .economic-detail-item-wrapper {
      margin: 22.5px 0 !important;
      justify-content: flex-start;
    }

    .economic-detail-info {
      width: 100% !important;
    }

    .economic-mechanism-detail-wrapper {
      width: 100% !important;
    }
  }
`

export const StyledEconomicDetailItemWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 41px 0;

  .economic-detail-info {
    margin-left: 25px;
    width: 460px;

    .economic-detail-info-title {
      font-style: normal;
      font-weight: normal;
      font-size: 21px;
      line-height: 31px;
      color: #191c1e;
      margin-bottom: 7px;
    }

    .economic-detail-info-description {
      font-style: normal;
      font-weight: normal;
      font-size: 21px;
      line-height: 31px;
      color: #9598ab;
    }
  }

  .economic-detail-img {
    width: 70px;
    height: 70px;
  }
  @media screen and (max-width: 640px) {
    margin: 22.5px 0 !important;
    justify-content: flex-start;

    .economic-detail-img {
      width: 45px;
      height: 45px;
    }

    .economic-detail-info {
      width: 100% !important;
    }

    .economic-mechanism-detail-wrapper {
      width: 100% !important;
    }
  }
`
